import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import SalesOrderListResults from 'components/SalesOrders/SalesOrderListResults';

const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType,
  salesOrders: state.salesOrders,
  customers: state.customers,
  products: state.products,
  idGen: state.idGen,
  user: state.user
});

const SalesOrderList = (props) => (
  <>
    <Helmet>
      <title>Sales Order | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <Box sx={{ mt: 3 }}>
          <SalesOrderListResults
            activeUserType={props.activeUserType}
            salesOrders={props.salesOrders}
            customers={props.customers}
            products={props.products}
            user={props.user}
          />
        </Box>
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (SalesOrderList);
